import { ChangeDetectionStrategy, Component, Input, OnInit, Renderer2 } from '@angular/core'

import { PlayerListenerComponentDirective } from '../../../base-component/player-listener.component'
import { ITrack } from '../../../Interface/track'
import { PlayerLogic } from '../../../player/AngPlayer'
import { CartService } from '../../../services/cart.service'
import { RoutingPathService } from '../../../services/environment.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { TrackInCartService } from '../../../services/track-in-cart.service'
import { AppType } from '../../../types/app.type'

@Component({
  selector: 'bmcore-player',
  templateUrl: './bmcore-player.component.html',
  styleUrls: ['./bmcore-player.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcorePlayerComponent extends PlayerListenerComponentDirective<ITrack> implements OnInit {
  @Input() appType: AppType
  @Input() colorSettingsMode = false

  @Input() showVerificationIcon = false
  @Input() showLikeBtn = false
  @Input() showFavouriteBtn = false
  @Input() showShareBtn = false

  lg: LgType
  checkoutPage: string

  constructor(
    public player: PlayerLogic,
    protected cartService: CartService,
    private i18nService: I18nService,
    private renderer: Renderer2,
    public trackInCartService: TrackInCartService,
    private routingPathService: RoutingPathService
  ) {
    super(player, cartService)
    this.checkoutPage = this.routingPathService.getCheckoutUrl()
  }

  ngOnInit() {
    super.ngOnInit()
    this.lg = this.i18nService.getLanguageForPage()
  }

  wantAddBeat(event: MouseEvent, beatId: number) {
    /* No parent scroll on modal scroll */
    this.renderer.addClass(document.body, 'modal-open')

    this.wantToAddBeat(event, beatId)
  }

  checkIsTrackInCart(id: number) {
    return this.trackInCartService.checkIsTrackInCart(id)
  }
}
